module.exports = __webpack_public_path__ + "static/img/Male Avatar.629f314d.jpg";